import styled from '@emotion/styled'
import color from '../../../constant/colors'
import { useRouter, useSelectedBenefitType } from '../../../utils/helper'
import Menu from './Menu'
import Noti from './Noti'
import * as paths from '../../../constant/path'
import Profile from './Profile'
import BEELogo from '../../../assets/images/base/BEE_LOGO.png'
import HambergerMenu from './HambergerMenu'
import ShopMenu from './ShopMenu'
import { useScreen, mobile } from '../../../utils/responsive-helper'
import { useGetNotificationCount, useReadNotificationAll } from '../../../services/notification/notification-query'
import { Link } from 'react-router-dom'
import { useEffect, useMemo } from 'react'
import { useGetAllSelectedBenefits, useGetAllSelfBenefitsType, useGetEnrollmentActivePeriod, useGetSelfBenefitsSelectChoice, useGetEnrollmentSelectPeriod } from '../../../services/enrollment/enrollment-query'
import { BenefitType } from '../../../services/enrollment/enrollment-types'

const Layout = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${color.WHITE};
  height: 80px;
  border-bottom: 1px solid ${color.CHOICES_PRIMARY};
  ${mobile} {
    height: 90px;
  }
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1172px;
  padding: 0 16px;
`

const MenuGroup = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

const LogoGroup = styled(Link)`
  display: flex;
  align-items: center;
  column-gap: 16px;
`

const Logo = styled.img`
  height: 24px;
`

const AppHeader = () => {
  const { pathname } = useRouter()
  const { isMobile } = useScreen()
  const { data: notiCount = 0, refetch: getNotificationCount } = useGetNotificationCount()
  const { mutate: setReadNotificationAll } = useReadNotificationAll()
  const { data: enrollmentSelectPeriod } = useGetEnrollmentSelectPeriod()
  const { data: enrollmentActivePeriod } = useGetEnrollmentActivePeriod()
  const { isFlexi } = useSelectedBenefitType()

  const isHighlightShop = useMemo(() => {
    const inShopBrands = pathname.includes(paths.shopBrand().split('/')[1])
    const inShopCategory = pathname.includes(paths.shopCategory().split('/')[1])
    const inEnrollment = pathname.includes(paths.enrollment().split('/')[1])
    return inShopBrands || inShopCategory || inEnrollment
  }, [pathname])

  // const isShopSection = useMemo(() => {
  //   return (
  //     pathname.startsWith(paths.coupon()) ||
  //     pathname.startsWith(paths.order()) ||
  //     pathname.startsWith(paths.product()) ||
  //     pathname.startsWith(paths.promotion()) ||
  //     pathname.startsWith(paths.promotionCategory()) ||
  //     pathname.startsWith(paths.shop())
  //   )
  // }, [pathname])

  const isHiddenMenu = useMemo(() => {
    if (!enrollmentSelectPeriod) return false
    if (!enrollmentActivePeriod) return true
    return enrollmentSelectPeriod.benefitYearId <= enrollmentActivePeriod.benefitYearId
  }, [enrollmentSelectPeriod, enrollmentActivePeriod])

  const isShopSection = false

  useEffect(() => {
    if (pathname === paths.notification()) {
      setReadNotificationAll()
      getNotificationCount()
    }
  }, [pathname, getNotificationCount, setReadNotificationAll])

  const menuListItem = useMemo(() => {
    return [
      {
        title: 'Home', path: paths.home(),
        isActive: pathname.startsWith(paths.home())
      },
      {
        title: 'News',
        path: paths.news(),
        isActive: pathname.startsWith(paths.news()),
        isHidden: isHiddenMenu
      },
      {
        title: 'Play',
        path: paths.play(),
        isActive: pathname.startsWith(paths.play()),
        isHidden: isHiddenMenu
      },
      // {
      //   title: 'Well-Being',
      //   path: paths.wellBeing(),
      //   isActive: pathname.startsWith(paths.wellBeing()),
      // },
      {
        title: 'Benefits',
        path: paths.enrollment(),
        isActive: pathname.startsWith(
          paths.enrollment(),
        ),
      },
      // {
      //   title: 'Health Checkup',
      //   path: paths.healthCheckup(),
      //   isActive: pathname.startsWith(
      //     paths.healthCheckup(),
      //   ),
      // },
      {
        title: 'E-Claims',
        path: paths.eClaim(),
        isHidden: !isFlexi || isHiddenMenu,
        isActive: pathname === paths.eClaim(),
      },
      {
        title: 'Marketplace',
        path: paths.shop(),
        isActive: pathname.startsWith(paths.shop()),
        isHidden: isHiddenMenu
      },
    ]
  }, [isFlexi, pathname, isHiddenMenu])

  return (
    <>
      {isShopSection ? (
        <ShopMenu />
      ) : (
        <Layout>
          <Header>
            <LogoGroup to={paths.home()}>
              <Logo
                src={BEELogo}
              />
            </LogoGroup>
            <MenuGroup>
              {!isMobile ? (
                <>
                  {menuListItem.map((menu, index) => (
                    <Menu key={index} path={menu.path} isActive={menu.isActive} isHidden={menu.isHidden}>
                      {menu.title}
                    </Menu>
                  ))}
                  {/* <Link to={paths.notification()}>
                    <Noti count={notiCount} />
                  </Link> */}
                  <Profile />
                </>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  {/* <Link to={paths.notification()}>
                    <Noti count={notiCount} />
                  </Link> */}
                  <HambergerMenu count={notiCount} menuList={menuListItem} />
                </div>
              )}
            </MenuGroup>
          </Header>
        </Layout>
      )}
    </>
  )
}

export default AppHeader
